// extracted by mini-css-extract-plugin
export default {"paragraph":"CoreParagraph-module--paragraph--c5ab9","isStyleWide":"CoreParagraph-module--isStyleWide--10604"};